import Vue from "vue";
import Vuex from "vuex";
import createPersistedstate from "vuex-persistedstate";

const req = require.context("./modules", false, /\.js$/);
let modules = {};
req.keys().forEach((key) => {
  const k = key.match(/(.*\/)*([^.]+).*/)[2];
  modules[k] = req(key).default;
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  plugins: [
    createPersistedstate({
      key: "store", 
      reducer(state) {
        return {
          ...state.base,
        };
      },
    }),
  ],
});
